import React, { useMemo } from 'react';
import { useSelector } from "react-redux";
import { selectAllDepartments } from "./data/departments.duck";
import Layout from '@shared/ui/organisms/layout/Layout';
import { useParams } from "react-router";
import { WorkPlannerContainer } from '@shared/ui/molecules/work-planner/WorkPlannerStructure';
import { WallPlannerDatesRow } from "@features/wall-planner/pages/components/WallPlannerDatesRow";
import { WallPlannerUserRow } from "@features/wall-planner/pages/components/WallPlannerUserRow";
import { WithWeeksInCurrentCalendarMonth } from '@features/whereabouts/hooks/WithWeekInCurrentCalendarMonth';
import { WallPlannerDepartmentPlan } from "@features/wall-planner/pages/components/WallPlannerDepartmentPlan";
import { PageTitle } from '@shared/ui/atoms/PageTitle';

export function DepartmentsUserPage(props: Props) {
  const departments = useSelector(selectAllDepartments);
  const params: any = useParams();
  const weeksInMonth = WithWeeksInCurrentCalendarMonth();

  const department = useMemo(() => {
    if (params.departmentId) {
      return departments.find(d => d.id === parseInt(params.departmentId));
    }
  }, [departments, params.departmentId]);

  if (!department) {
    return null;
  }

  return (
    <Layout>
      {department && <>
        <PageTitle text={department.name} showTodayButton={true} style={{marginBottom: 24}} />

        <WorkPlannerContainer id={'workPlannerContainer'}>
          <WallPlannerDatesRow weeksInMonth={weeksInMonth} />
          <WallPlannerDepartmentPlan department={department} isFirst={true} weeksInMonth={weeksInMonth} />
          <WallPlannerUserRow id={'workPlannerRow'} />
          <WallPlannerUserRow id={'workPlannerRow'} />
          <WallPlannerUserRow id={'workPlannerRow'} />
          <WallPlannerUserRow id={'workPlannerRow'} />
        </WorkPlannerContainer>
      </>}
    </Layout>
  )
}

interface Props {
}
